import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FaChalkboardTeacher, FaBookOpen, FaUsers } from "react-icons/fa";

import ph77 from "../image/ph77.jpg";
import ph23 from "../image/ph23.jpg";
import ph7 from "../image/ph7.jpg";
import ph8 from "../image/ph8.jpg";
import ph2 from "../image/ph2.jpg";
import ph12 from "../image/ph9.jpg";
import background from "../image/back.png";

const galleryImages = [ph77, ph23, ph7, ph8, ph2, ph12];

const AboutUs = () => {
  useEffect(() => {
    const NUM_BALLS = 18;
    const balls = [];
    const colors = [
      "#f1f5ff", // very light blue
      "#a5b4fc", // soft indigo
      "#fcd34d", // soft yellow
      "#fca5a5", // soft red
      "#6ee7b7", // soft green
      "#f9a8d4", // soft pink
      "#c7d2fe", // blue-gray
      "#fff"
    ];
    const container = document.getElementById("randomBallsBg");
    if (!container) return;
    container.innerHTML = "";
    const footer = document.querySelector("footer");
    let footerHeight = 0;
    if (footer) {
      footerHeight = footer.offsetHeight;
    }
    const W = window.innerWidth;
    const H = window.innerHeight - footerHeight;
    for (let i = 0; i < NUM_BALLS; i++) {
      const ball = document.createElement("div");
      const size = Math.random() * 18 + 12;
      ball.className = "random-ball";
      ball.style.width = `${size}px`;
      ball.style.height = `${size}px`;
      ball.style.background = colors[Math.floor(Math.random() * colors.length)];
      ball.style.left = `${Math.random() * (W - size)}px`;
      ball.style.top = `${Math.random() * (H - size)}px`;
      container.appendChild(ball);
      balls.push({
        el: ball,
        x: parseFloat(ball.style.left),
        y: parseFloat(ball.style.top),
        dx: (Math.random() - 0.5) * 1.5,
        dy: (Math.random() - 0.5) * 1.5,
        size,
      });
    }
    let running = true;
    function animate() {
      if (!running) return;
      for (const b of balls) {
        b.x += b.dx;
        b.y += b.dy;
        if (b.x < 0 || b.x > W - b.size) b.dx *= -1;
        if (b.y < 0 || b.y > H - b.size) b.dy *= -1;
        b.x = Math.max(0, Math.min(W - b.size, b.x));
        b.y = Math.max(0, Math.min(H - b.size, b.y));
        b.el.style.transform = `translate(${b.x}px, ${b.y}px)`;
      }
      requestAnimationFrame(animate);
    }
    animate();
    return () => {
      running = false;
      if (container) container.innerHTML = "";
    };
  }, []);
  return (
    <div className="relative min-h-screen flex justify-center items-start bg-lightblue overflow-hidden px-2 md:px-0">
      {/* Animated Random Balls Background */}
      <div className="random-balls-bg" id="randomBallsBg"></div>
      {/* Main Content */}
      <div className="relative z-10 w-full max-w-[90vw] mx-auto text-center p-10">
        <motion.h1
          className="text-5xl font-bold text-blue-900 mb-6"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          About Us
        </motion.h1>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          Empowering students through quality education and expert guidance. Our
          mission is to provide personalized tutoring to help every student
          achieve their academic dreams.
        </p>

        {/* Features Section */}
        <div className="grid md:grid-cols-3 gap-10 mt-12">
          {[FaChalkboardTeacher, FaBookOpen, FaUsers].map((Icon, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-lg text-center"
              whileHover={{ scale: 1.05 }}
            >
              <Icon className="text-6xl text-blue-700 mx-auto" />
              <h2 className="text-2xl font-semibold mt-4">
                {["Expert Tutors", "Comprehensive Materials", "Community Learning"][index]}
              </h2>
              <p className="text-gray-600 mt-2">
                {[
                  "Our experienced tutors provide the best learning experience tailored to each student.",
                  "Access well-structured study materials to enhance learning and understanding.",
                  "Join a vibrant learning community that fosters collaboration and academic success.",
                ][index]}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Photo Gallery Section */}
        <div className="mt-16">
          <h2 className="text-5xl font-bold text-blue-900 text-center mb-6">
            Our Stories
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {galleryImages.map((src, index) => (
              <motion.div
                key={index}
                className="overflow-hidden rounded-xl shadow-lg"
                whileHover={{ scale: 1.05 }}
              >
                <img
                  src={src}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-48 object-cover"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
